import { getPath } from './pagePaths'

interface LocationState {
    from: Partial<Location> | Location
}

export const sanitizeLocationState = (
    locationState?: LocationState
): LocationState => {
    if (
        locationState?.from?.pathname === getPath('authPage') ||
        !locationState?.from?.pathname ||
        !locationState?.from?.pathname?.startsWith('/')
    ) {
        return {
            from: {
                pathname: getPath('homePage'),
            },
        }
    }

    return locationState
}
